import LoadingSkeleton from '../LoadingSkeleton';
import React from 'react';

const Page = React.lazy(()=>import('./ContractInput'))

export default function LazyContractInput(props){
  return <React.Suspense fallback={<LoadingSkeleton height={36.5} />}>
    <Page {...props} />
  </React.Suspense>
}
